import { createContext } from 'react';
import { ThemeContextValue } from './types';
import { defaultBranding } from './defaultTheme';

/**
 * Theme context for white-label branding
 */
export const ThemeContext = createContext<ThemeContextValue>({
  branding: defaultBranding,
  isLoading: false,
  isCustomBranding: false,
});
